import React from 'react';
import {
  ItemContainer,
  ItemContent,
  ItemsContainer,
} from './compSetSelector.styled';
import { Body4 } from './../../../common/typography';
import TransparentChecked from './../../../common/icons/TransparentChecked';
import { getItem, setItem } from './../../../../utils/localStorage';

export function CompSetSelector ({
  compSetList,
  setSelectedCompset,
  setCompsetOpen,
  selectedHotel,
  selectedItem,
}) {
  function handleClick (compSet) {
    setItem('selectedCompset', compSet.compSetNumber);
    const selectedCompsetbyHotel = getItem('selectedCompsetbyHotel') || [];
    const updatedItems = selectedCompsetbyHotel.map((item) =>
      item.hotelId === selectedHotel
        ? { ...item, selectedCompset: getItem('selectedCompset') }
        : item
    );
    setItem('selectedCompsetbyHotel', JSON.stringify(updatedItems));
    setSelectedCompset(compSet.compSetNumber.toString());
    setCompsetOpen(false);
  }

  return (
    <ItemsContainer>
      {compSetList.map((compSet) => (
        <ItemContainer
          key={compSet.compSetName}
          onClick={() => {
            handleClick(compSet);
          }}
          className={compSet.compSetNumber === selectedItem ? 'selected' : ''}
        >
          <ItemContent>
            <Body4 color="eerieBlack">{compSet.compSetName}</Body4>
            {compSet.compSetNumber === selectedItem && <TransparentChecked />}
          </ItemContent>
        </ItemContainer>
      ))}
    </ItemsContainer>
  );
}
